import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import NotificationModal from "../modal/modal";

function Action() {
  const [modalNotify, setModalNotify] = useState(false);
  return (
    <div id="action" className="section-padding py-5">
      <NotificationModal
        show={modalNotify}
        onHide={() => setModalNotify(false)}
      />
      <Container>
        <div className="rounded-4 overflow-hidden position-relative shadow-xl px-4 py-5 text-center text-white"
          style={{ background: 'linear-gradient(135deg, var(--primary-color) 0%, #1e40af 100%)' }}>

          {/* Abstract Shapes */}
          <div className="position-absolute top-0 end-0 bg-secondary opacity-10 rounded-circle blur-3xl"
            style={{ width: '300px', height: '300px', transform: 'translate(30%, -30%)' }}></div>
          <div className="position-absolute bottom-0 start-0 bg-accent opacity-10 rounded-circle blur-3xl"
            style={{ width: '300px', height: '300px', transform: 'translate(-30%, 30%)' }}></div>

          <div className="position-relative" style={{ zIndex: 1 }}>
            <Row className="justify-content-center">
              <Col md={8} lg={6}>
                <h2 className="display-5 fw-bold mb-4">
                  Ready to start your journey?
                </h2>
                <p className="lead mb-5 opacity-90 text-light">
                  Join our global network of creators and backers.
                  Bridge the gap between inspiring ideas and reality today.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Button
                    onClick={() => setModalNotify(true)}
                    className="btn btn-warning text-dark fw-bold px-5 py-3 rounded-pill shadow-lg hover-scale border-0"
                    style={{ background: 'var(--accent-color)' }}
                  >
                    Get Started
                  </Button>
                  <Button
                    onClick={() => setModalNotify(true)}
                    className="btn btn-outline-light fw-bold px-5 py-3 rounded-pill hover-scale backdrop-blur-sm"
                  >
                    Login
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
}
export default Action;
